function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#9E9E9E"
        d="M8 2.5c-.3 0-.5.2-.5.5v5c0 .1.1.3.1.4l3 3c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L8.5 7.8V3c0-.3-.2-.5-.5-.5z"
      />
      <path
        fill="#9E9E9E"
        d="M8 0C3.6 0 0 3.6 0 8c0 2.4 1.1 4.6 2.8 6H.5c-.3 0-.5.2-.5.5s.2.5.5.5h4v-4.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.9C2 12.1 1 10.2 1 8c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7h-.5c-.3 0-.5.2-.5.5s.2.5.5.5H8c4.4 0 8-3.6 8-8s-3.6-8-8-8z"
      />
    </svg>
  );
}

export default Icon;
